import { shortRootGetter } from '../../../utils/vuex'
import { filter, findIndex, prop } from '../../../utils/xp.v1'

export default {
  myUid: shortRootGetter('account/myUid'),
  isValidMobile: shortRootGetter('account/isValidMobile'),

  inDCService(_, getters) {
    return getters.inService('diancang')
  },

  in520Service(_, getters) {
    return getters.inService('520')
  },

  // isNonUser(_, getters) {
  //   return !getters.mySoftType || getters.mySoftType === 'none'
  // },

  myAward(state) {
    const awards = state.myAwards || []
    const pendList = filter(awards, (item) => !item.awardStatus)
    const doneList = filter(awards, (item) => item.awardStatus > 0)
    // console.log(JSON.stringify(doneList))
    return {
      allCount: awards.length,
      pendDays: pendList.length * 15,
      doneDays: doneList.length * 15,
      pendList,
      doneList
    }
  },

  inService(state) {
    return (softType) =>
      findIndex(
        state.myPrivList,
        (item) => item.softType === softType && item.inService > 0
      ) > -1
  },

  getUser(state) {
    return (uid) => (uid > 0 ? prop(state.UserMap, uid, null) : null)
  }
}
